import { apiPrefix } from '../constants'

export default {
  addIngredient: {
    type: 'post',
    url: `${apiPrefix}ingredient`,
  },
  deleteIngredient: {
    type: 'delete',
    url: `${apiPrefix}ingredient`,
  },
  getIngredients: {
    type: 'get',
    url: `${apiPrefix}ingredients`,
  },
  getRecipeIngredients: {
    type: 'get',
    url: `${apiPrefix}ingredients`,
  },
  getIngredient: {
    type: 'get',
    url: `${apiPrefix}ingredient`,
  },
  updateIngredient: {
    type: 'put',
    url: `${apiPrefix}ingredient`,
  },
  getIngredientHeaders: {
    type: 'get',
    url: `${apiPrefix}ingredientHeaders`,
  },
}
